import { ChangeDetectionStrategy, Component } from '@angular/core';
import moment from 'moment';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    template: `<p id="copyright-text">{{ 'footer.text' | translate: { year: year } }}</p>`,
    styles: [
        `
            #copyright-text {
                margin: 0;
                text-align: center;
            }
        `,
    ],
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
    readonly year: string = moment().format('yyyy');
}
